import {
  ON_THE_FLY_MODULE_ID,
  PLAY_MODULE_ID,
  DISCOVERY_MODULE_ID,
  OBJECTION_MODULE_ID,
  PITCH_MODULE_ID,
  COLD_CALL_MODULE_ID,
} from "@/lib/modules/ids";
import { scenarioModuleLabel } from "@/lib/role-plays/scenario-types";

export {
  ON_THE_FLY_MODULE_ID,
  PLAY_MODULE_ID,
  DISCOVERY_MODULE_ID,
  OBJECTION_MODULE_ID,
  PITCH_MODULE_ID,
  COLD_CALL_MODULE_ID,
};

// On-the-Fly keys objections in the singular; its four practice categories are
// the matching modules, so each takes its name from the one scenario-type table
// (lib/role-plays/scenario-types.js) rather than spelling it again.
export const ON_THE_FLY_SCENARIO_TYPE_CONFIG = {
  DISCOVERY: {
    label: scenarioModuleLabel("DISCOVERY"),
    moduleIds: [DISCOVERY_MODULE_ID],
  },
  OBJECTION: {
    label: scenarioModuleLabel("OBJECTIONS"),
    moduleIds: [OBJECTION_MODULE_ID],
  },
  PITCH: {
    label: scenarioModuleLabel("PITCH"),
    moduleIds: [PITCH_MODULE_ID],
  },
  COLD_CALL: {
    label: scenarioModuleLabel("COLD_CALL"),
    moduleIds: [COLD_CALL_MODULE_ID],
  },
  OTHER: {
    label: "Uncategorized",
    moduleIds: [
      PLAY_MODULE_ID,
      DISCOVERY_MODULE_ID,
      OBJECTION_MODULE_ID,
      PITCH_MODULE_ID,
      COLD_CALL_MODULE_ID,
    ],
  },
};

export const ON_THE_FLY_SCENARIO_TYPES = Object.keys(
  ON_THE_FLY_SCENARIO_TYPE_CONFIG
);

export const ON_THE_FLY_PRACTICE_SCENARIO_TYPES =
  ON_THE_FLY_SCENARIO_TYPES.filter((type) => type !== "OTHER");

export const ON_THE_FLY_SCENARIO_TYPE_LABELS = Object.fromEntries(
  Object.entries(ON_THE_FLY_SCENARIO_TYPE_CONFIG).map(([type, config]) => [
    type,
    config.label,
  ])
);
